import { render, staticRenderFns } from "./defaultCompanyLogo.vue?vue&type=template&id=7a20660c&"
import script from "./defaultCompanyLogo.vue?vue&type=script&lang=js&"
export * from "./defaultCompanyLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports